export default "__VITE_ASSET__CQm81SEo__ 400w, __VITE_ASSET__C55RDbI0__ 800w, __VITE_ASSET__DRkkG12Z__ 1200w";